import { Component, OnInit , ViewChild, ElementRef, AfterViewInit, HostListener, Renderer2, Input, OnChanges } from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';


import * as moment from 'moment';
import * as _ from 'underscore';
import { StickyDirection } from '@angular/cdk/table';

@Component({
  selector: 'app-presale',
  templateUrl: './presale.component.html',
  styleUrls: ['./presale.component.css']
})
export class PresaleComponent implements OnInit {


  @Input() utilData_PreSale : any;
  @Input() speedingData_PreSale : any;
  @Input() harshEventSumData_PreSale : any;
  @Input() totalDays : any;



  preSaleView : string = 'utilView';
  
  //Utilization presale
  
  utilTblPreSaleDataSource :any = [];
  utilPreSaleColumns : string[] = ['sortBase', 'vehicleType', 'daysOperational', 'totalMileage', 'sum_MovingTimeHr', 'averageOfSum_MovingTimeHr', 'dailyMiles'];
  @ViewChild('sortUtilPreSale') sortUtilPreSale: MatSort;
  @ViewChild('paginatorUtilPreSale') paginatorUtilPreSale: MatPaginator;

 //speeding presale
  speedingTblPreSaleDataSource :any = [];
  speedingPreSaleColumns : string[] = ['sortBase', 'vehicleType', 'derived_Under_5', 'derived_5To10', 'derived_10To15', 'derived_Over_15', 'derived_Total_Speeding', 'sum_TotalMiles'];
  @ViewChild('sortSpeedingPreSale') sortSpeedingPreSale: MatSort;
  @ViewChild('paginatorSpeedingPreSale') paginatorSpeedingPreSale: MatPaginator;
  FleetData : any;


  //harshevent presale
  harshEventTblPreSaleDataSource :any = [];
  harshEventPreSaleColumns : string[] = ['sortBase', 'vehicleType', 'sum_Harsh_Brake', 'derived_sum_Harsh_Brake_Per1k', 'sum_Harsh_Corner','derived_sum_Harsh_Corner_Per1k', 'sum_Harsh_Quick_Accelaration', 'derived_sum_Harsh_Quick_Accelaration_Per1k', 'sum_TotalMiles'];
  @ViewChild('sortHarshEventPreSale') sortHarshEventPreSale: MatSort;
  @ViewChild('paginatorHarshEventPreSale') paginatorHarshEventPreSale: MatPaginator;

  yearAndMonth: string = '';

  constructor() { }

  onPresaleViewValChange(preSaleView : string)
  {
    this.preSaleView = preSaleView;

  }

  generateUtilPreSaleTable()
  {
   
    
    if(!this.utilData_PreSale) return;
    //for sorting on contional VIN or Vehicleid 
    this.utilData_PreSale.forEach((item) => {
      item.sortBase = item.vin && item.vin !== 'N/A' ? item.vin.replace(item.vin.slice(0, (item.vin.length) - 6), "").toString() +'/' : '/' + item.vehicleId
    });

    let utilViewData = _.toArray(this.utilData_PreSale);


    this.utilTblPreSaleDataSource = new MatTableDataSource(utilViewData);
    //sort on derived columns
    this.utilTblPreSaleDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'averageOfSum_MovingTimeHr':
          return (item.daysOperational == 0 ? 0 : item.sum_MovingTimeHr / item.daysOperational);
        
        
        default:
          return item[property];
      }
    };
    
    
    this.utilTblPreSaleDataSource.sort = this.sortUtilPreSale;
    this.utilTblPreSaleDataSource.paginator = this.paginatorUtilPreSale;
    

  }

  generateSpeedingPreSaleTable() {

    if(!this.speedingData_PreSale) return;
    //for sorting on contional VIN or Vehicleid 
    this.speedingData_PreSale.forEach((item) => {
      item.sortBase = item.vin && item.vin !== 'N/A' ? item.vin.replace(item.vin.slice(0, (item.vin.length) - 6), "").toString() +'/' : '/' + item.vehicleId
    });

    let speedingViewData = _.toArray(this.speedingData_PreSale);
    
    this.speedingTblPreSaleDataSource = new MatTableDataSource(speedingViewData);

    //sort on derived columns
    this.speedingTblPreSaleDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'derived_Under_5':
          return (item.sum_TotalMovingHr == 0 ? 0 : item.sum_Speeding_Under_5mph_ByTime / 3600 * 100 / item.sum_TotalMovingHr);
        case 'derived_5To10':
          return (item.sum_TotalMovingHr == 0 ? 0 : item.sum_Speeding_5_10mph_ByTime / 3600 * 100 / item.sum_TotalMovingHr);

        case 'derived_10To15' :
          return (item.sum_TotalMovingHr == 0 ? 0 : item.sum_Speeding_10_15mph_ByTime / 3600 * 100 / item.sum_TotalMovingHr);
        
        case 'derived_Over_15':
          return (item.sum_TotalMovingHr == 0 ? 0 : item.sum_Speeding_Over_15mph_ByTime / 3600 * 100 / item.sum_TotalMovingHr);
        case 'derived_Total_Speeding':
          return item.sum_TotalMovingHr == 0 ? 0 : 
          (item.sum_Speeding_Under_5mph_ByTime + item.sum_Speeding_5_10mph_ByTime + item.sum_Speeding_10_15mph_ByTime + item.sum_Speeding_Over_15mph_ByTime) / 3600 *100 / item.sum_TotalMovingHr;
        
        default:
          return item[property];
      }
    };

    this.speedingTblPreSaleDataSource.sort = this.sortSpeedingPreSale;
    this.speedingTblPreSaleDataSource.paginator = this.paginatorSpeedingPreSale;
  }

  generateHarshEventPreSaleTable() {

    if(!this.harshEventSumData_PreSale) return;
    //sum up harshEventData for the table

   
    let harshEventDataSum = this.harshEventSumData_PreSale;


      //for sorting on contional VIN or Vehicleid 
    harshEventDataSum.forEach((item) => {
      item.sortBase = item.vin && item.vin !== 'N/A' ? item.vin.replace(item.vin.slice(0, (item.vin.length) - 6), "").toString() +'/' : '/' + item.vehicleId
    });

    let harshEventViewData = _.toArray(harshEventDataSum);
    
    this.harshEventTblPreSaleDataSource = new MatTableDataSource(harshEventViewData);

    //sort on derived columns
    this.harshEventTblPreSaleDataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'derived_sum_Harsh_Brake_Per1k':
          return ((item.sum_TotalMiles == 0 || item.sum_Harsh_Brake == 0) ? 0: item.sum_Harsh_Brake  * 1000 / item.sum_TotalMiles );
        case 'derived_sum_Harsh_Corner_Per1k':
          return ((item.sum_TotalMiles == 0 || item.sum_Harsh_Corner == 0) ? 0: item.sum_Harsh_Corner * 1000 / item.sum_TotalMiles);

        case 'derived_sum_Harsh_Quick_Accelaration_Per1k' :
          return ((item.sum_TotalMiles == 0 || item.sum_Harsh_Quick_Accelaration == 0) ? 0 : item.sum_Harsh_Quick_Accelaration * 1000 / item.sum_TotalMiles);

         
        
        default:
          return item[property];
      }
    };

    this.harshEventTblPreSaleDataSource.sort = this.sortHarshEventPreSale;
    this.harshEventTblPreSaleDataSource.paginator = this.paginatorHarshEventPreSale;


  }

  vehicleFleetSum()
  {
    if(!this.speedingData_PreSale) return;
    let dataSet = this.speedingData_PreSale;
    let u5Sum = 0, _5T10Sum = 0, _10T15Sum = 0, o15Sum = 0, totalMovingHrSum =0;// totalMileSum = 0;

    dataSet.forEach((data) =>
    {
        u5Sum += data.sum_Speeding_Under_5mph_ByTime;
        _5T10Sum += data.sum_Speeding_5_10mph_ByTime;
        _10T15Sum += data.sum_Speeding_10_15mph_ByTime;
        o15Sum += data.sum_Speeding_Over_15mph_ByTime;
        totalMovingHrSum += data.sum_TotalMovingHr;
    })
    //console.log("obj", {"u5Sum": u5Sum, "_5T10Sum" : _5T10Sum, "_10T15Sum": _10T15Sum, "o15Sum": o15Sum, "totalMileSum": totalMovingHrSum });
    return {"u5Sum": u5Sum, "_5T10Sum" : _5T10Sum, "_10T15Sum": _10T15Sum, "o15Sum": o15Sum, "totalMovingHrSum": totalMovingHrSum };
  }
  ngOnInit(): void {
  }

  ngOnChanges(): void{
    

    this.generateUtilPreSaleTable();
    this.generateSpeedingPreSaleTable();
    this.generateHarshEventPreSaleTable();

    this.FleetData = this.vehicleFleetSum();
    

    if (this.utilData_PreSale && this.utilData_PreSale.length >0) this.yearAndMonth = (this.utilData_PreSale[0].yearMonthFrom / 100).toFixed(0) + "-" + (this.utilData_PreSale[0].yearMonthFrom.toString().substring(4)) ;
    
  }

}
